import { Box, Center, Column, Row, Typography } from '@tempmee/react';
import { OutlineChevronRightIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Checkbox } from '~/commonComponents';
import { Date as JobDate } from '~/components/Schedule/components/JobCard/components/Date';
import { getJobStatus } from '~/components/Dashboard/ReceiptList/utils';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { format, parse } from 'date-fns';
import { useNavigate } from 'react-router';

interface IInterviewRowProps {
  date: string;
  endTime: string;
  isInvited?: boolean;
  isSelected: boolean;
  onsiteInterviewId: string;
  profession: string;
  startTime: string;
  status: string;
  subProfession: string | null;
  onToggle: (id: string) => void;
}

export const InterviewRow = ({
  date,
  endTime,
  isInvited = false,
  isSelected,
  onsiteInterviewId,
  profession,
  startTime,
  status,
  subProfession,
  onToggle,
}: IInterviewRowProps) => {
  const navigate = useNavigate();
  const { color, label } = getJobStatus(status);

  return (
    <Row
      align="stretch"
      aria-label={`Interview on ${date}`}
      className={isInvited ? 'shadow-xs' : 'shadow-xs hover__shadow-sm'}
      data-testid="interview-row"
      gap={3}
      px={5}
      py={2}
      role={isInvited ? undefined : 'button'}
      style={{
        borderRadius: 8,
        cursor: isInvited ? 'default' : 'pointer',
        opacity: isInvited ? 0.6 : 1,
      }}
      onClick={isInvited ? undefined : () => navigate(`/dashboard/job/${onsiteInterviewId}`)}
    >
      <Center
        px={3}
        role={isInvited ? undefined : 'button'}
        onClick={
          isInvited
            ? undefined
            : (e) => {
                e.stopPropagation();
                onToggle(onsiteInterviewId);
              }
        }
      >
        <Checkbox checked={isSelected} />
      </Center>
      <Row className="flex-1" gap={3}>
        <JobDate
          backgroundColor={color}
          localDate={format(parse(date, 'EEE, MMM d, yyyy', new Date()), 'yyyy-MM-dd')}
        />
        <Column className="flex-1">
          <Typography bold>
            {UserSubProfession.getName(subProfession || '') || UserProfession.getName(profession)}
          </Typography>
          <Typography>
            {startTime} - {endTime}
          </Typography>
          <Typography color={color}>{label}</Typography>
        </Column>
      </Row>
      <Box style={{ alignSelf: 'center' }}>
        {isInvited ? (
          <Typography size="body_small" color={colors.primary[500]}>
            Invited
          </Typography>
        ) : (
          <OutlineChevronRightIcon size={24} color={colors.secondary[500]} />
        )}
      </Box>
    </Row>
  );
};
